import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  created() {
    setDocTitle("404", this);
  },
  mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  },
};
